import { RouteItem } from '@eastcoal/router/types/route'

export const memberAuditPersonRoute: RouteItem = {
  title: '个人认证',
  hideInMenu: true,
  children: [
    {
      title: '认证详情',
      path: '/audit/person/detail',
      Component: () => import('./Detail')
    }
  ]
}
